module.exports = __webpack_public_path__ + "img/our-customers.90e0aaec.jpg";